import Shopping from "./Shopping";
import styles from "./Shopping.module.css";
import useAmazonShopping from "./useAmazonShopping";

const AmazonShoppingItem = ({ onClick, shoppingItemInfo }) => {
  return (
    <div className={styles.ShoppingItem} onClick={() => onClick(shoppingItemInfo)}>
      <div className={styles.shoppingItemImgWrapper}>
        <img src={shoppingItemInfo.image} alt="" />
      </div>
      <div className={styles.ShoppingItemInfo}>
        <div>{shoppingItemInfo.title}</div>
        <span>$ {shoppingItemInfo.price}</span>
      </div>
    </div>
  );
};

const AmazonShopping = props => {
  return <Shopping {...props} useShopping={useAmazonShopping} shoppingItem={AmazonShoppingItem} />;
};

export { AmazonShopping };
